module.exports = __webpack_public_path__ + "static/media/rogue1_preview.6fa530d4.jpg";